// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Nodata } from "./Nodata";
import { NodataFromJSON, NodataFromJSONTyped, NodataToJSON, NodataToJSONTyped } from "./Nodata";

/**
 *
 * @export
 * @interface RasterCreateOptions
 */
export interface RasterCreateOptions {
  /**
   *
   */
  format?: string;
  /**
   *
   */
  bbox: string;
  /**
   *
   */
  projection?: string | null;
  /**
   *
   */
  width?: number | null;
  /**
   *
   */
  height?: number | null;
  /**
   *
   */
  start?: number | null;
  /**
   *
   */
  nodata?: Nodata | null;
}

/**
 * Check if a given object implements the RasterCreateOptions interface.
 */
export function instanceOfRasterCreateOptions(value: object): value is RasterCreateOptions {
  if (!("bbox" in value) || value["bbox"] === undefined) return false;
  return true;
}

export function RasterCreateOptionsFromJSON(json: any): RasterCreateOptions {
  return RasterCreateOptionsFromJSONTyped(json, false);
}

export function RasterCreateOptionsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RasterCreateOptions {
  if (json == null) {
    return json;
  }
  return {
    format: json["format"] == null ? undefined : json["format"],
    bbox: json["bbox"],
    projection:
      json["projection"] === undefined
        ? undefined
        : json["projection"] === null
        ? null
        : json["projection"],
    width: json["width"] === undefined ? undefined : json["width"] === null ? null : json["width"],
    height:
      json["height"] === undefined ? undefined : json["height"] === null ? null : json["height"],
    start: json["start"] === undefined ? undefined : json["start"] === null ? null : json["start"],
    nodata:
      json["nodata"] === undefined
        ? undefined
        : json["nodata"] === null
        ? null
        : NodataFromJSON(json["nodata"]),
  };
}

export function RasterCreateOptionsToJSON(json: any): RasterCreateOptions {
  return RasterCreateOptionsToJSONTyped(json, false);
}

export function RasterCreateOptionsToJSONTyped(
  value?: RasterCreateOptions | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    format: value["format"],
    bbox: value["bbox"],
    projection: value["projection"],
    width: value["width"],
    height: value["height"],
    start: value["start"],
    nodata: NodataToJSON(value["nodata"]),
  };
}
